import { type Location } from '../services/api.types';

export const LOCATION_SEARCH_PAGE_SIZE = 50;

export const formatLocationDisplay = (location: Location) => (
  `${location.diacriticsName}, ${location.county.name}`
);

export const locationMatchesQuery = (location: Location, query: string) => {
  const search = query.trim().toLowerCase();

  if (!search) {
    return true;
  }

  return (
    location.diacriticsName.toLowerCase().includes(search) ||
    location.name.toLowerCase().includes(search) ||
    location.county.name.toLowerCase().includes(search)
  );
};

export const mergeUniqueLocations = (...locationGroups: Location[][]) => {
  const seen = new Set<string>();
  const locations: Location[] = [];

  locationGroups.flat().forEach((location) => {
    if (!seen.has(location.id)) {
      seen.add(location.id);
      locations.push(location);
    }
  });

  return locations;
};

export const haveSameLocationIds = (first: Location[], second: Location[]) => (
  first.length === second.length && first.every((location, index) => location.id === second[index]?.id)
);
